import { isArray } from 'lodash';
import requester from 'utils/requester';
import api from 'config/api';
import { hideModal, showModal } from 'actions/modal';
import { MODAL_TYPES } from 'constants/modal-types';
import SpatialNavigationWrapper from 'components/navigation/SpatialNavigationWrapper';
import * as types from './types';

export const checkUserNotifications = () => async dispatch => {
  dispatch({ type: types.FETCH });

  return await requester({
    method: 'GET',
    url: `${api.host}${api.endpoints.notifications}`,
    appendParams: false,
  });
};

export const displayUserNotification = notification => dispatch => {
  if (notification.title) {
    const lastFocusedElem = document.activeElement;

    const handleClose = () => {
      SpatialNavigationWrapper.focus(lastFocusedElem);
      dispatch(hideModal());
    };

    dispatch(
      showModal(MODAL_TYPES.NOTIFICATION, {
        onModalBack: handleClose,
        title: notification.title,
        buttons: [{ text: 'OK', handler: handleClose }],
      }),
    );
  }
};

export const showFirstUserNotification = notifications => dispatch => {
  if (isArray(notifications)) {
    const [firstNotification] = notifications;

    if (firstNotification) {
      dispatch(displayUserNotification(firstNotification));
    }
  }
};
